/*
 * Copyright (c) Orion Developments Ltd and the Orion Health group of companies (2001 - 2021).
 *
 * This document is subject to copyright. Except as permitted by copyright law
 * applicable to you, no part of this publication may be reproduced or
 * transmitted in any form or by any means, electronic or mechanical, including
 * photocopying, recording, downloading, or any information storage and
 * retrieval system, without permission in writing from Orion Developments
 * Limited. Infringers of copyright render themselves liable for prosecution.
 */

import { useReactOidc } from "@axa-fr/react-oidc-context";
import { Button } from "@material-ui/core";
import { GridRenderCellParams } from '@mui/x-data-grid';
import { AccessRequest } from "./Interfaces";
import { useAccessRequestCallbacks } from "./RequestAccessStatusContext";

export function ApproveRejectAction(params: GridRenderCellParams) {
  const { oidcUser } = useReactOidc();
  let action = ""
  const accessRequest = params.row as AccessRequest
  const reloadCallback = useAccessRequestCallbacks()
  if (params.field === "Approve") {
    action = "Approved"
  }
  if (params.field === "Reject") {
    action = "Rejected"
  }
  const postData = async () => {
    try {
      const body = {
        user: accessRequest.User,
        status: action,
        requestedDate: accessRequest.RequestedDate,
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${oidcUser.access_token}`
        },
        body: JSON.stringify(body)
      };
      const url = `${process.env.REACT_APP_URL}/user/waiting-request-action`
      const response = await fetch(url, requestOptions)
      if (response.status !== 200) {
        reloadCallback(`Something went wrong while trying to ${params.field.toLowerCase()} your request: ${await response.text()}`, false)
      } else {
        reloadCallback(`Success! Access request has been ${action.toLowerCase()}`, true)
      }
    } catch (e) {
      reloadCallback(`Something went wrong while trying to ${params.field.toLowerCase()} your request`, false)
    }
  }
  return (
    <Button variant="contained" onClick={postData} color="primary">{params.field}</Button>
  );
}